export const userDeviceIdLocalStorageKey = "userDeviceId";
